const config = window.__appInsightsConfig;

// Exported so tests can deterministically await completion of the async SDK load.
export const ready =
  config && config.connectionString
    ? import(/* webpackChunkName: "app-insights" */ '@microsoft/applicationinsights-web').then(
        ({ ApplicationInsights }) => {
          const appInsights = new ApplicationInsights({
            config: {
              connectionString: config.connectionString,
              enableDebug: !!config.enableDebug,
              disableFetchTracking: false,
              autoTrackPageVisitTime: true,
              // Chrome flags any 'unload' listener as a Permissions Policy violation (it's being
              // phased out browser-wide). The SDK still flushes telemetry via 'beforeunload'/'pagehide'.
              disablePageUnloadEvents: ['unload'],
            },
          });

          appInsights.loadAppInsights();
          appInsights.trackPageView();

          // telemetry-helper.js's resolveFromWindow() checks this property.
          window.appInsights = appInsights;
        },
      )
    : Promise.resolve();
